import { apiClient } from './client'

export interface UserProfile {
  id: number
  name: string
  email: string
  role: string
  is_active: number
  email_verified: boolean
  created_at: string | null
  updated_at: string | null
  admin_notes?: string | null
  last_name: string | null
  first_name: string | null
  middle_name: string | null
  nickname: string | null
}

export interface UserProfileResponse {
  user: UserProfile
  can_edit_profile: boolean
  can_edit_admin_notes: boolean
  is_self: boolean
}

export async function getUserProfile(userId: number): Promise<UserProfileResponse> {
  const response = await apiClient.get(`/api/users/${userId}`)
  return response.data as UserProfileResponse
}

export interface UpdateOwnProfilePayload {
  name?: string
  last_name?: string | null
  first_name?: string | null
  middle_name?: string | null
  nickname?: string | null
  current_password?: string
  new_password?: string
}

export interface UpdateAdminNotesPayload {
  admin_notes: string | null
}

export async function updateUserProfile(
  userId: number,
  payload: UpdateOwnProfilePayload | UpdateAdminNotesPayload,
): Promise<UserProfileResponse> {
  const response = await apiClient.put(`/api/users/${userId}`, payload)
  return response.data as UserProfileResponse
}
